import React from 'react';
import {
  Page,
} from '@react-pdf/renderer';
import PdfImageFromAzureWithOptions from '../../../atoms/PdfImageFromAzureWithOptions';

const ClinicalGuidePage = ({
  pageNumber
}): JSX.Element => {
  let _pageNumber = pageNumber;
  if (pageNumber < 10) { _pageNumber = `00${pageNumber}`; }
  else if (pageNumber < 100) { _pageNumber = `0${pageNumber}`; }
  return (
    <Page size="LEGAL" orientation="landscape">
      <PdfImageFromAzureWithOptions
        fileName={`Clinical Guide v06.2022_Page_${_pageNumber}.png`}
        folderPath="assets/clinical_guides/"
      />
    </Page>
  );
};

export default ClinicalGuidePage;
